import { canv } from '@/canv/global.js'
import { isBrowser } from '@/canv/utils.js'
import {
    getBoolProperty,
    getStringProperty,
    getNumberProperty,
    getColorProperty,
    drawRoundedRect,
} from '@/canv/utils.js';

export class textItem {

    constructor(symbol, fontSize, fontStyle, fontColor, fontBold, fontStrike, backgroundColor, symbolLink = "") {
        this.symbol = symbol;
        this.fontSize = fontSize;
        this.fontStyle = fontStyle;
        this.fontColor = fontColor;
        this.fontBold = fontBold;
        this.isStriked = fontStrike;
        this.backgroundColor = backgroundColor;
        this.link = symbolLink;

        this.width = this.calcWidth();
        this.height = this.calcHeight();
    }

    calcHeight() {
        canv.ctx.save();
        // Всегда считаем bold, чтобы изменение fontBold не влиял на высоту
        canv.ctx.font =  "bold " + this.fontSize.toString() + "px " + this.fontStyle.toString();
        // Тут вообще-то надо canv.ctx.measureText(this.symbol), но в такмо случае в стикере все строки разного размера, некрасиво
        // не делаем actualBoundingBoxDescent, так как высота буквы для нас начинаеся от baseLine
        var metrics = canv.ctx.measureText("F");
        var actualHeight = metrics.actualBoundingBoxAscent; //+ metrics.actualBoundingBoxDescent;
        canv.ctx.restore();
        return actualHeight;
    }

    calcWidth() {
        canv.ctx.save();
        canv.ctx.font = this.fontBold + " " + this.fontSize.toString() + "px " + this.fontStyle.toString();
        var width = canv.ctx.measureText(this.symbol).width;
        canv.ctx.restore();
        return width;
    }

    getHeight() {
        return this.height;
    };

    getWidth() {
        return this.width;
    }

    updateDims() {
        if (!isBrowser()) return;
        this.height = this.calcHeight();
        this.width = this.calcWidth();
    }

    // для statesManager


    getState(fixType) {

        var state = {};

        if (fixType == "full") {
            state["isStriked"] = this.isStriked;
            state["fontBold"] = this.fontBold;
            state["fontColor"] = this.fontColor;
            state["fontSize"] = this.fontSize;
            state["fontStyle"] = this.fontStyle;
            state["backgroundColor"] = this.backgroundColor;
            state["symbol"] = this.symbol;
            state["link"] = this.link;
        }

        return state;
    }

    loadState(stateObj, fixType) {

        if (fixType == "full") {
            this.isStriked = getBoolProperty("isStriked", stateObj);
            this.fontBold = getStringProperty("fontBold", stateObj);
            this.fontColor = getColorProperty("fontColor", stateObj);
            this.fontSize = getNumberProperty("fontSize", stateObj);
            this.fontStyle = getStringProperty("fontStyle", stateObj);
            this.backgroundColor = getColorProperty("backgroundColor", stateObj, "transparent");
            // symbol оставляем как есть
            this.symbol = stateObj["symbol"];
            this.link = getStringProperty("link", stateObj);
        }

        if (this.symbol.includes('�')) {
            this.symbol = "";
            this.updateDims();
        }

        this.updateDims();

    }


    symbol = "";
    fontSize = 30;
    fontStyle = "serif";
    fontColor = "black";
    fontBold = "";
    isStriked = false;
    backgroundColor = "transparent";
    link = "";

    height = 0;
    width = 0;
}



export class textLine {

    constructor(lineIndex, parent, bullettedList, align) {

        this["parent"] = parent;
        this.lineIndex = lineIndex;
        this.bullettedList = bullettedList;
        this.alignment = align;

        this.startX = parent.startX;

        if (lineIndex == 0) {
            this.startY = parent.startY;
        } else {
            this.startY = parent.lines[lineIndex - 1].startY + this.textHeight;
        }
    }

    // updateDimensions

    updateWidthHeight() {

        this.textWidth = 0;
        for (var i = 0; i < this.items.length; i++) {
            this.textWidth += this.items[i].getWidth();
        }
        if (this["parent"].isOnlyEmptyLine()) {
            this.textWidth = this["parent"].onlyEmptyLineWidth;
        }

        if (this["parent"].shouldUseGreyText()) {
            this.textWidth = this["parent"].greyTextWidth;
        }

        this.textHeight = 0;
        for (var i = 0; i < this.items.length; i++) {
            var compHeight = this.items[i].getHeight();
            if (compHeight > this.textHeight) {
                this.textHeight = compHeight;
            }
        }
        if (this.textHeight == 0) {
            this.textHeight = this["parent"].emptyLineHeight;
        }

        this.verticalPadding = this.textHeight * 2/3;
        this.horizontalPadding = this.verticalPadding / 3;

        this.textHeight += 2 * this.verticalPadding;
        this.textWidth += 2 * this.horizontalPadding;


        if (this.bullettedList) {
            this.bulletedRadius = this.textHeight / 10;
            this.bulletedPaddingX = this.horizontalPadding;
            this.textWidth += 2*this.bulletedRadius + this.bulletedPaddingX;
        }
    }

    updatePosition(lastLineYBottom, parentStartX, lineIndex) {

        this.lineIndex = lineIndex;

        this.startX = parentStartX;

        if (this.alignment == "center") {
            this.startX += this["parent"].width / 2 - this.textWidth / 2;
        } else if (this.alignment == "right") {
            this.startX += this["parent"].width - this.textWidth;
        }

        this.textStartX = this.startX + this.horizontalPadding;
        if (this.bullettedList) {
            this.textStartX += 2*this.bulletedRadius + this.bulletedPaddingX;
        }


        if (lastLineYBottom != undefined) {
            this.startY = lastLineYBottom + this.textHeight;
        } else {
            this.startY = this["parent"].startY;
        }

        var nextItemStartX = this.textStartX;

        for (var i = 0; i < this.items.length; i++) {
            this.items[i].startX = nextItemStartX;
            this.items[i].startY = this.startY - this.verticalPadding;
            nextItemStartX += this.items[i].getWidth();
        }
    }


    // draw

    drawPlaceholder() {
        if (this.items.length == 0) return;

        canv.ctx.fillStyle = "#9c9c9c";
        canv.ctx.fillRect(this.startX, this.startY - this.textHeight + this.verticalPadding, this.textWidth, this.textHeight - 2*this.verticalPadding);
    }

    draw() {

        var currentX = this.textStartX;
        for (var i = 0; i < this.items.length; i++) {

            if (this.items[i].fontColor != "transparent") {
                canv.ctx.fillStyle = this.items[i].fontColor;
                if (this.items[i].link) canv.ctx.fillStyle = "#0B99FF";
                canv.ctx.font = this.items[i].fontBold + " " + this.items[i].fontSize.toString() + "px " + this.items[i].fontStyle.toString();
                canv.ctx.fillText(this.items[i].symbol, this.items[i].startX, this.startY - this.verticalPadding);
            }

            currentX += this.items[i].getWidth();
        }

        if (this["parent"].shouldUseGreyText()) {
            canv.ctx.fillStyle = "#9c9c9c";
            canv.ctx.font = this["parent"].fontBold + " " + this["parent"].fontSize.toString() + "px " + this["parent"].fontStyle.toString();
            canv.ctx.fillText(this["parent"].greyText, currentX, this.startY - this.verticalPadding);
        }

        this.drawBulleted();
        this.drawStrike();
        this.drawLinkUnderline();
    }

    drawBulleted() {
        if (!this.bullettedList) return;

        canv.ctx.save();
        canv.ctx.fillStyle = this.items.length ? this.items[0].fontColor : "black";

        const cx = this.startX + this.horizontalPadding + this.bulletedRadius;
        const cy = this.startY - this.textHeight / 2;

        canv.ctx.beginPath();
        canv.ctx.arc(cx, cy, this.bulletedRadius, 0, Math.PI * 2, false);
        canv.ctx.closePath();
        canv.ctx.fill();
        canv.ctx.restore();
    }

    drawStrike() {

        var startPosition = -1;
        var strikeWidth = 0;

        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].isStriked) {
                if (startPosition == -1) {
                    startPosition = i;
                }
                strikeWidth += this.items[i].getWidth();
            } else {
                if (startPosition != -1) {
                    var strikeHeight = this.textHeight / 10;
                    canv.ctx.fillStyle = "#2d2d2d";
                    canv.ctx.fillRect(this.items[startPosition].startX, this.startY - this.textHeight/2 - strikeHeight / 2, strikeWidth, strikeHeight);

                    startPosition = -1;
                    strikeWidth = 0;
                }
            }
        }

        // проверяем последний символ
        if (startPosition != -1) {
            var strikeHeight = this.textHeight / 10;
            canv.ctx.fillStyle = "#2d2d2d";
            canv.ctx.fillRect(this.items[startPosition].startX, this.startY - this.textHeight/2 - strikeHeight / 2, strikeWidth, strikeHeight);
        }

    }



    // links

    drawLinkUnderline() {

        var startPosition = -1;
        var strikeWidth = 0;

        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].link) {
                if (startPosition == -1) {
                    startPosition = i;
                }
                strikeWidth += this.items[i].getWidth();
            } else {
                if (startPosition != -1) {
                    var strikeHeight = this.verticalPadding / 6;
                    canv.ctx.fillStyle = "#0B99FF";
                    canv.ctx.fillRect(this.items[startPosition].startX, this.startY - this.verticalPadding/2 - strikeHeight/2, strikeWidth, strikeHeight);

                    startPosition = -1;
                    strikeWidth = 0;
                }
            }
        }

        // проверяем последний символ
        if (startPosition != -1) {
            var strikeHeight = this.verticalPadding / 6;
            canv.ctx.fillStyle = "#0B99FF";
            canv.ctx.fillRect(this.items[startPosition].startX, this.startY - this.verticalPadding/2 - strikeHeight/2, strikeWidth, strikeHeight);
        }

    }






    // Tools

    isOverLineBox() {
        var pt = canv.actionManager.getActionPoint();
        var x = pt.x;
        var y = pt.y;

        if (x >= this["parent"].startX && x <= this.startX + this["parent"].width && y <= this.startY && y >= this.startY - this.textHeight) {
            return true;
        }

        return false;
    }

    // Используется для отрисовки selection
    getIntervalWidth(left, right) {
        var width = 0;
        for (var i = left; i <= right; i++) {
            width += this.items[i].getWidth();
        }

        return width;
    }

    // для processCopy
    getIntervalText(left, right) {
        var selectedText = "";
        for (var i = left; i < right; i++) {
            selectedText += this.items[i].symbol;
        }

        return selectedText;
    }

    // для frame side menu
    getText() {
        var text = ``;

        for (var i = 0; i < this.items.length; i++) {
            text += this.items[i].symbol;
        }

        return text;
    }

    // FITS

    getOverlayToken(hardWidth) {
        var data = {
            "tokenPosition": -1,
            "overlayPosition": -1
        };

        var width = this.textStartX - this.startX + this.horizontalPadding; // не очень понятно. Кажется тут хотелось посчитать дополнительную ширину относительно только букв.

        for (var i = 0; i < this.items.length; i++) {

            if (this.items[i].symbol == " ") {
                data["tokenPosition"] = -1;
            } else {
                if (data["tokenPosition"] == -1) {
                    data["tokenPosition"] = i;
                }
            }


            if (width + this.items[i].getWidth() > hardWidth) {
                data["overlayPosition"] = i;
                return data;
            }

            width += this.items[i].getWidth();
        }

        return data;
    }

    getAllowedTokens(freeSpace) {

        var lastTokenEnd = -1;

        var width = 0;

        // считаем пробелы за однобуквенные слова, чтобы переносить пробелы вверх
        // иначе часто остаются строки с одним пробелом, поэтому однопробельная строка не удаляется -> мы не могли переносить на первуб строку сразу несколько строк

        for (var i = 0; i < this.items.length; i++) {

            if (width + this.items[i].getWidth() > freeSpace) {
                return lastTokenEnd;
            }

            if (this.items[i].symbol == " ") {
                lastTokenEnd = i;
            }

            // если строка заканчивается не пробелом, то нужно засчитать последний токен
            if (i == this.items.length - 1 && this.items[i].symbol != " ") {
                lastTokenEnd = i;
            }


            width += this.items[i].getWidth();
        }

        return lastTokenEnd;
    }





    // Далее функции для меню

    enrichItemValues(field, start, end, values) {
        if (start < 0 || end > this.items.length) return;

        for (var i = start; i < end; i++) {
            let currentValue = "";
            if (field == "bold") {
                currentValue = this.items[i].fontBold;
            } else if (field == "strike") {
                currentValue = this.items[i].isStriked;
            } else if (field == "color") {
                currentValue = this.items[i].fontColor;
            } else if (field == "size") {
                currentValue = this.items[i].fontSize;
            } else if (field == "backgroundColor") {
                currentValue = this.items[i].backgroundColor;
            } else if (field == "link") {
                currentValue = this.items[i].link;
            }

            var index = values.indexOf(currentValue);
            if (index != -1) continue;

            values.push(currentValue);
        }
    }

    setTextSize(value, left = 0, right = this.items.length) {
        for (var i = left; i < right; i++) {
            this.items[i].fontSize = value;
            this.items[i].updateDims();
        }
    }

    setTextColor(value, left, right) {
        for (var i = left; i < right; i++) {
            this.items[i].fontColor = value;
        }
    }

    setTextBold(value, left, right) {

        for (var i = left; i < right; i++) {
            this.items[i].fontBold = value;
            this.items[i].updateDims();
        }

    }

    setTextStrike(value, left, right) {
        for (var i = left; i < right; i++) {
            this.items[i].isStriked = value;
        }
    }

    setTextBulleted(value) {
        this.bullettedList = value;
    }

    setTextAlign(value) {
        this.alignment = value;
    }

    setBackgroundColor(value, left, right) {
        for (var i = left; i < right; i++) {
            this.items[i].backgroundColor = value;
        }
    }

    setLink(link, left, right) {

        for (var i = left; i < right; i++) {
            this.items[i].link = link;
        }

    }





    // Для statesManager

    getState(fixType) {
        var state = {};

        if (fixType == "full") {
            state["bullettedList"] = this.bullettedList;
            state["alignment"] = this.alignment;
            state["enterExists"] = this.enterExists;
            state["items"] = [];

            for (var i = 0; i < this.items.length; i++){
                state["items"].push(this.items[i].getState("full"));
            }
        }

        return state;
    }

    loadState(stateObj, fixType) {

        if (fixType == "full") {
            this.bullettedList = getBoolProperty("bullettedList", stateObj);
            this.alignment = getStringProperty("alignment", stateObj);
            this.enterExists = getBoolProperty("enterExists", stateObj);

            for (var i = 0; i < stateObj["items"].length; i++){
                if (this.items.length == i) {
                    var itemData = stateObj["items"][i];
                    const fontSize = getNumberProperty("fontSize", itemData);
                    const fontStyle = getStringProperty("fontStyle", itemData);
                    const fontColor = getColorProperty("fontColor", itemData);
                    const fontBold = getStringProperty("fontBold", itemData);
                    this.items.push(new textItem(itemData["symbol"], fontSize, fontStyle, fontColor, fontBold));
                    this.items[this.items.length - 1].loadState(itemData, "full");
                    continue;
                }
                this.items[i].loadState(stateObj["items"][i], fixType);
            }

            if (this.items.length > stateObj["items"].length) {
                this.items.splice(stateObj["items"].length, this.items.length - stateObj["items"].length);
            }
        }
    }

    highlightText(startIndex, endIndex) {
        let highlightWidth = 0;
        let highlightStartX = undefined;

        if (startIndex > this.items.length - 1) {
            return;
        }

        for (var i = 0; i < this.items.length; i++) {
            if (i >= startIndex && i <= endIndex) {
                if (highlightStartX === undefined) {
                    highlightStartX = this.items[i].startX;
                }
                highlightWidth = highlightWidth + this.items[i].getWidth();
            }
        }

        if (highlightStartX === undefined) {
            return;
        }

        const highlightStartY =  this.startY - this.textHeight;
        const highlightHeight = this.textHeight;

        canv.ctx.save();
        canv.ctx.globalAlpha = 0.3;
        canv.ctx.fillStyle = "#FFA629";
        drawRoundedRect(highlightStartX, highlightStartY, highlightWidth, highlightHeight, 5);
        canv.ctx.fill();
        canv.ctx.restore();
    }



    items = [];


    // выгружаемые свойства
    enterExists = false;
    bullettedList = false;
    alignment = "left";

    // расчитываются в updateDims ----
    lineIndex = 0;
    bulletedRadius = 0;
    bulletedPaddingX = 0;
    startX = 0;
    startY = 0;
    textHeight = 0;
    textWidth = 0;
    textStartX = 0;
    // --------------------------------

    // константы
    verticalPadding = 0;
    horizontalPadding = 0;








    // Не используется, svg text ------------------------------------------------------------------------------

    getLetterSvg(width, height) {
        return `
        M10 10 h 80 v 80 h -80 Z
        `;
        return `
        <svg width="` + width + `" height="` + height + `" viewBox="0 0 70 65" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28.02 65H0.0700001V61.75C1.71667 60.7967 3.23333 60.1033 4.62 59.67C6.00667 59.15 7.35 58.8033 8.65 58.63V6.5C6.83 6.06666 5.18333 5.59 3.71 5.07C2.23667 4.55 1.02333 3.98666 0.0700001 3.38V0H69.36V3.38C68.2333 4.07333 66.9767 4.72333 65.59 5.33C64.2033 5.93666 62.6 6.32666 60.78 6.5V58.63C63.7267 59.15 66.5867 60.19 69.36 61.75V65H41.41V61.75C42.2767 61.1433 43.2733 60.58 44.4 60.06C45.6133 59.54 47.1733 59.0633 49.08 58.63V5.72H20.35V58.63C22.0833 59.15 23.5567 59.67 24.77 60.19C25.9833 60.71 27.0667 61.23 28.02 61.75V65Z" fill="black"/>
        </svg>

        `;
    }

    applyItemMarkupTemplate(item, x, y) {
        return `<text x="` + x + `" y="` + y + `" fill="` + item.fontColor + `" font-size="` + item.fontSize + `" text-rendering="optimizeSpeed">` + item.symbol + `</text>`;
    }

    getSvgMarkup() {

        var textMarkup = ``;

        var currentX = this["parent"].horizontalPadding;

        /*for (var i = 0; i < this.items.length; i++) {
            textMarkup += this.applyItemMarkupTemplate(this.items[i], currentX, this.textHeight - this.verticalPadding);
            currentX += this.items[i].getWidth();
        }

        var template = `
            <svg viewBox="0 0 ` + this.textWidth + ` ` + this.textHeight + `" width="` + this.width + `" height="` + this.height + `" xmlns="http://www.w3.org/2000/svg">
                ` + textMarkup + `
            </svg>
        `;*/

        var template = ``;
        for (var i = 0; i < this.items.length; i++) {
            textMarkup += this.getLetterSvg(this.items[i], this.items[i].width, this.items[i].height);
            currentX += this.items[i].getWidth();
        }


        return template;
    }

    regenMock(item) {
        /*let svg = this.getLetterSvg(item.width, item.height);
        let blob = new Blob([svg], {type: 'image/svg+xml'});
        let url = URL.createObjectURL(blob);
        let image = document.createElement('img');
        image.src = url;
        item.imageMock = image;
        image.addEventListener('load', () => URL.revokeObjectURL(url), {once: true});*/

        var m = new Path2D('M28.02 65H0.0700001V61.75C1.71667 60.7967 3.23333 60.1033 4.62 59.67C6.00667 59.15 7.35 58.8033 8.65 58.63V6.5C6.83 6.06666 5.18333 5.59 3.71 5.07C2.23667 4.55 1.02333 3.98666 0.0700001 3.38V0H69.36V3.38C68.2333 4.07333 66.9767 4.72333 65.59 5.33C64.2033 5.93666 62.6 6.32666 60.78 6.5V58.63C63.7267 59.15 66.5867 60.19 69.36 61.75V65H41.41V61.75C42.2767 61.1433 43.2733 60.58 44.4 60.06C45.6133 59.54 47.1733 59.0633 49.08 58.63V5.72H20.35V58.63C22.0833 59.15 23.5567 59.67 24.77 60.19C25.9833 60.71 27.0667 61.23 28.02 61.75V65Z');
        item.mock = m;
    }

    regenAllMocks() {
        for (var i = 0; i < this.items.length; i++) {
            this.regenMock(this.items[i]);
        }
    }

    drawMock() {
        var currentShift = 0;
        canv.ctx.save();
        canv.ctx.translate(this.startX, this.startY);
        for (var i = 0; i < this.items.length; i++) {
            canv.ctx.strokeStyle = "black";
            //canv.ctx.strokeRect(currentX, this.startY - this.textHeight + this.verticalPadding, this.items[i].width, this.items[i].height);
            //canv.ctx.drawImage(this.items[i].imageMock, currentX, this.startY - this.textHeight + this.verticalPadding, this.items[i].width, this.items[i].height);
            canv.ctx.translate(currentShift, 0);
            canv.ctx.fill(this.items[i].mock);
            currentShift += this.items[i].getWidth();
        }
        canv.ctx.restore();
    }

}
